export const interImports = `
/* Inter variable – normal */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src:
    url('/fonts/Inter-VariableFont_opsz,wght.ttf') format('truetype');
}

/* Inter variable – italic */
@font-face {
  font-family: 'Inter';
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src:
    url('/fonts/Inter-Italic-VariableFont_opsz,wght.ttf') format('truetype');
}

html { font-synthesis-weight: none; font-synthesis-style: none; font-optical-sizing: auto; }
`
